import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';


@Component({
    selector: 'vertrag',
    templateUrl: 'vertrag.component.html',
    styleUrls: ['vertrag.component.css']
})
/** vertrag component*/
export class VertragComponent implements OnInit {
    private errorMessage: any;

    constructor(private route: ActivatedRoute) {

    }

    ngOnInit(): void {
    }

}


// WEBPACK FOOTER //
// ./src/app/_vertrag/vertrag.component.ts